import styled from 'styled-components';
import { Button } from '@mollybet/ui';

export const ButtonCell = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

export const StyledButton = styled(Button)`
  margin: 0px 5px;
  width: fit-content;
  white-space: nowrap;
  min-width: 4rem;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const WarningButton = styled(StyledButton).attrs((p) => ({
  theme: { ...p.theme, primary: p.theme.warning },
}))``;

export const DangerButton = styled(StyledButton).attrs((p) => ({
  theme: { ...p.theme, primary: p.theme.danger },
}))``;
